import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class Variant {

    constructor(item = {}) {
        this.subscription_product_variant_id = item.subscription_product_variant_id || null;
        this.name = item.name || {
            el: "",
            en: "",
            it: ""
        };
        this.description = item.description || {
            el: "",
            en: "",
            it: ""
        };
        this.inventory = item.inventory || null;
        this.sku_number = item.sku_number || null;
        this.price = item.price || null;
        this.visible = item.visible || null;
        this.attribute_option_ids = item.attribute_option_ids || [];
        this.attributes = item.attributes || [];
    }

    
    static getVariants = (q='') =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/variants${q}`
        );
    
        static createVariant = (body) =>
        API.post(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/variants`, body
        );
    
        static updateVariant = (id,body) =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/variants/${id}`, body
        );
    
        static deleteVariant = (id) =>
        API.delete(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/variants/${id}`
        );

}
